var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"CDB-LoaderIcon CDB-LoaderIcon--big"},[_c('svg',{staticClass:"CDB-LoaderIcon-spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"CDB-LoaderIcon-path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }